module.exports = __webpack_public_path__ + "static/img/image_solutions_optics_07.9cf7f88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_optics_07.png
// module id = Bw49
// module chunks = 10